//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

import axios, { CancelToken } from "axios";
import { GChart } from "vue-google-charts";
export default {
  components: {
    GChart,
  },
  props: {
    chartData: Array,
    chartTitle: String,
  },
  data() {
    return {
      // chartAData: [],
      chartOptions: {
        backgroundColor: {
          fill: "#ffffff",
          fillOpacity: 0.5,
        },
        title: "",
        fontSize: 14,
        fontName: "Roboto Condensed",
        color: "#ffffff",
        // textStyle: {
        //   fontName: 'Open Sans',
        //   bold: true,
        //   italic: true,
        //   fontSize: 18,
        //   color: '#ffffff',
        // },
        legend: {
          position: "none",
        },
        bar: {
          groupWidth: "70%",
        },
        hAxis: {
          format: "decimal",
        },
        vAxis: {
          minValue: 0,
          // maxValue: 100,
          gridlines: {
            count: 0,
          },
        },
        animation: {
          duration: 1200,
          easing: "out",
          startup: true,
        },
        chartArea: {
          backgroundColor: {
            fill: "#99ddff",
            fillOpacity: 0.1,
            // 'opacity': 100
          },
          // left: 50,
          top: 30,
          bottom: 30,
          // right: 0,
          // width: '400px',
          // height: '200%'
        },
        seriesType: "bars",
        series: {
          1: {
            type: "line",
          },
        },
        annotations: {
          textStyle: {
            fontName: "Times-Roman",
            fontSize: 12,
            bold: true,
            italic: false,
            // The color of the text.
            // color: "#871b47",
            // The color of the text outline.
            // auraColor: '#000000',
            // The transparency of the text.
            // opacity: 0.8
          },
        },
      },
      chartEvents: {
        select: () => {
          const table = this.$refs.gChart.chartObject;
          const selection = table.getSelection();
          const onSelectionMeaasge =
            selection.length !== 0 ? "row was selected" : "row was diselected";
          // console.log(selection);
        },
      },
    };
  },
  async mounted() {
    this.chartOptions.title = this.chartTitle;
  },
  methods: {},
};
